<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-dropdown-menu buttonRounded="large" dialogLabel="Hilfe">
  @if (enabled) {
    <alfa-help-button button-content data-test-id="help-menu-button" />
  }

  @if (apiRootStateResource?.resource | hasLink: apiRootLinkRel.DOCUMENTATIONS) {
    <ods-dropdown-menu-link-item
      caption="Benutzerleitfaden Alfa"
      text="PDF öffnen"
      [url]="apiRootStateResource.resource | getUrl: apiRootLinkRel.DOCUMENTATIONS"
      data-test-id="documentation"
    >
      <ods-file-icon icon fileType="pdf" size="medium" />
    </ods-dropdown-menu-link-item>
  }

  @if (apiRootStateResource?.resource?.impressumUrl) {
    <ods-dropdown-menu-link-item
      class="border-t"
      [url]="apiRootStateResource.resource.impressumUrl"
      text="Impressum"
      data-test-id="impressum"
    />
  }
</ods-dropdown-menu>
